/** @format */

import { Modal, Paper } from '@mui/material';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '300px',
  height: '300px',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto', // changed from 'scroll' to 'auto'
  scrollbarWidth: 'thin',
};

function ModalWrapper(props) {
  const { children, open, handleClose, size = {} } = props;
  return (
    <Modal open={open} onClose={handleClose}>
      <Paper style={{ ...style, ...size }}>{children}</Paper>
    </Modal>
  );
}

export default ModalWrapper;
